/* eslint-disable @typescript-eslint/no-misused-promises */
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import CustomFieldsHook from '../app/custom/CustomFieldsHook'
import CustomValidatorHook from '../app/custom/CustomValidatorHook'
import { AgentModals } from '../functions/agent/AgentModals'
import { confirmResetPasswordEmail, confirmResetPasswordPhone, login, resetPasswordEmail, resetPasswordPhone, verifyPhoneConfirm, verifyPhoneCreate, verifyResetPasswordEmail, verifyResetPasswordPhone } from '../store/actionsCreators/authActions'
import RulesModals from '../components/shared/auth/RulesModals'
import { useSearchParams } from 'react-router-dom'
import { type AppDispatch, type RootState, store } from '../store/store'
import {
    register,
    registerEnd,
    showLandlordDocumentRegistrationSwal
} from '../store/actionsCreators/authActions/registerAction'

import { scanFields } from '../store/actionsCreators/authActions/scanDocumentForRegisterActions'

import BackLoader from '../app/custom/loaders/BackLoader'
import { BSO_DEVELOP_MODE_ON_FRONT } from '../urls'
import { useAppDispatch, useAppSelector } from '../hooks/redux'
import { uploadPOA } from "../store/actionsCreators/authActions/landlordAuthCallbacks/uploadPOAForLandlordRegisterActions";
import { chooseLandlordType } from "../store/actionsCreators/authActions/landlordAuthCallbacks/chooseLandlordType";
import { getDynamicHeight } from '../functions/utils/getDynamicHeight'
import useMediaQuery from '../hooks/useMediaQuery'

export default function AuthPage(): JSX.Element {

    const location = useLocation().pathname.slice(6)
    const isDesktop = useMediaQuery("(min-width: 992px)"); const [searchParams] = useSearchParams()
    const [referralID, setReferralID] = useState<number | undefined>()
    const maxAttemptsScan = useAppSelector((state: RootState) => state.documents.maxAttemptsScan)
    // const dispatch = useAppDispatch()
    useEffect(() => {
        const id = searchParams.get('referral-id')
        if (id != null) {
            setReferralID(+id)
        }
        // if (store.getState().auth.userCATEGORY === 'Landlord') {
        //     dispatch(showLandlordDocumentRegistrationSwal(location))
        // }
    }, [location])

    let callback

    switch (location) {
        case 'login':
            callback = login
            break
        case 'register1':
            callback = verifyPhoneCreate
            break
        case 'phone_verify':
            callback = verifyPhoneConfirm
            break
        case 'register_scan_emirates_front':
            callback = scanFields
            break
        case 'register_scan_emirates':
            callback = scanFields
            break

        case 'register_scan_passport':
            callback = scanFields
            break
        case 'register_choose_landlord_type':
            callback = chooseLandlordType
            break
        case 'register_upload_poa':
            callback = uploadPOA
            break
        case 'write_yourself_fields':
            callback = registerEnd
            break

        case 'register2':
            callback = (data: any) =>
                async (dispatch: AppDispatch, getState: (state: RootState) => RootState) =>
                    await dispatch(register(data, referralID))
            break

        // reset password step 1
        case 'reset_password_way_email':
            callback = verifyResetPasswordEmail
            break
        case 'reset_password_way_phone':
            callback = verifyResetPasswordPhone
            break

        // reset password step 2  send otp
        case 'password_verify_email':
            callback = confirmResetPasswordEmail
            break

        case 'password_verify':
            callback = confirmResetPasswordPhone
            break

        // reset password step 3 confirm
        case 'reset_password_final_email':
            callback = resetPasswordEmail
            break
        case 'reset_password_final':
            callback = resetPasswordPhone
            break

        default:
            break
    }

    const modal = [AgentModals().find((modal: any) => modal.id === location)]

    const isDevFront = window.localStorage.getItem(BSO_DEVELOP_MODE_ON_FRONT)

    const formContent = (
        <CustomValidatorHook id={location} callback={callback}>
            <CustomFieldsHook modal={modal} isAuth={true} />
        </CustomValidatorHook>
    )

    if (isDesktop) { //  && location === 'login'
        return (
            <>
                <BackLoader />

                <div className="auth-desktop auth-foreground">
                    <div className="auth-desktop__inner">
                        {isDevFront === "true" ? (
                            <span className="badge badge-danger mb-3" style={{ width: "fit-content" }}>
                                DEV MODE FRONT
                            </span>
                        ) : null}

                        <div className="auth-desktop__brand">
                            <img alt="Logo" src="/assets/media/logo.png" className="h-60px" />
                        </div>

                        <div className="auth-desktop__card card shadow-sm m-0 w-100">
                            <div className="card-body p-5">{formContent}</div>
                        </div>
                    </div>
                </div>

            </>
        )
    }

    return (
        <>

            <div className={'page d-flex flex-column flex-row-fluid  auth-page'} >
                <div
                    className="header position-fixed top-0 start-0 end-0 bg-white h-auto shadow-sm fw-bold w-100"
                    style={{ paddingTop: '25px', zIndex: 9 }}
                >
                    {isDevFront === 'true' ? (
                        <span
                            className="badge badge-danger position-fixed"
                            style={{ zIndex: 9999999, left: 2, top: 52 }}
                        >
                            DEV MODE FRONT
                        </span>
                    ) : null}


                    <div className="mw-450px mx-auto w-100">
                        <div className="d-flex flex-row flex-fill justify-content-center m-4">
                            <img alt="Logo" src="/assets/media/logo.png" className="h-60px mx-auto" />
                        </div>
                    </div>
                </div>
                <div className=" my-4 m-0" style={{ height: `${Math.round(getDynamicHeight() / 8)}px` }}>
                </div>
                <div className="content d-flex flex-center flex-fill p-4 w-100 mw-450px mx-auto">
                    <div className="card shadow-sm m-0 w-100">
                        <div className="card-body p-4">
                            {formContent}
                        </div>
                    </div>
                </div>
                {!isDesktop && (location === 'login' || location === 'register1') && (
                    <div className="footer fixed-bottom start-0 end-0 bg-white shadow-sm fw-bold w-100">
                        <div className="mw-450px mx-auto">
                            <div className="d-flex flex-center flex-column-auto align-self-center p-4">
                                <div className="d-flex align-items-center fw-bold">
                                    <div className="text-muted text-hover-warning px-2 pb-6">
                                        <RulesModals row={'About BSO Club'} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className=" my-4 m-0" style={{ height: `${Math.round(getDynamicHeight() / 8)}px` }}></div>
            </div>
            <BackLoader />
        </>
    )
}
